// extracted by mini-css-extract-plugin
export default {"item":"Activity_Stories_item__9juqB","image":"Activity_Stories_image__S1Ha8"};